import "liquid-ajax-cart";
import "./components/cart";
import "./components/cart-popup-notification";
import "./components/sticky-add-to-cart";
import "./components/cart-gamification";
import "./components/gb-experiments";
import "./components/toggle-variant";
import './components/upsell-slider-side-cart';


window.addEventListener('featureManager::ready', () => {
  FeatureManager.onRunChange(
    { key: "upsell-slider-side-cart", variations: ["control", "variant"] },
    (variant) => {
      if (variant === "variant") {
        document.body.setAttribute("data-test-upsell-cart", "true");
      } else {
        document.body.removeAttribute("data-test-upsell-cart");
      }
    }
  );
});
